import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";

interface TrustedBy {
  id: string;
  company_name: string;
  logo_url: string;
  website_url?: string;
}

const TrustedBySection = () => {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState<TrustedBy[]>([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      const { data } = await supabase
        .from('trusted_by')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (data) setCompanies(data as TrustedBy[]);
    };

    fetchCompanies();
  }, []);

  if (companies.length === 0) return null;

  return (
    <section className="py-20 border-y border-border">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t("trustedBy.title")}</h2>
          <p className="text-muted-foreground text-lg">{t("trustedBy.subtitle")}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {companies.map((company) => (
            <div key={company.id} className="flex items-center justify-center p-4">
              {company.website_url ? (
                <a 
                  href={company.website_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:opacity-80 transition-opacity"
                >
                  <img 
                    src={company.logo_url} 
                    alt={company.company_name}
                    className="h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all"
                    loading="lazy"
                    width="126"
                    height="48"
                  />
                </a>
              ) : (
                <img 
                  src={company.logo_url} 
                  alt={company.company_name}
                  className="h-12 w-auto object-contain grayscale opacity-70"
                  loading="lazy"
                  width="126"
                  height="48"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;